// Centrala texter för kontextuella hjälp-tooltips (?)

export const helpHints: Record<string, { title: string; body: string }> = {
  "cv-upload": {
    title: "Ladda upp ditt CV",
    body: "Stödjer PDF, DOCX och vanlig text. Vi extraherar dina kompetenser och erfarenheter automatiskt – inget manuellt arbete krävs.",
  },
  "match-button": {
    title: "Matcha mot jobb",
    body: "Vi jämför ditt CV mot alla aktuella jobbannonser och rangordnar dem efter hur väl de matchar dina kompetenser.",
  },
  "job-filters": {
    title: "Sökfilter",
    body: "Begränsa sökningen med fritext, plats eller yrkeskategori. Inloggade kan spara favoritfilter för snabb åtkomst.",
  },
  "applications-tab": {
    title: "Mina ansökningar",
    body: "Håll koll på alla jobb du sökt – markera status som Sökt, Intervju, Erbjudande eller Avslag och anteckna fritt.",
  },
  "normalization-rules": {
    title: "Normaliseringsregler",
    body: 'Hjälper systemet förstå att t.ex. "JS", "Javascript" och "JavaScript" är samma kompetens. Förbättrar matchningen.',
  },
  "settings-menu": {
    title: "Inställningar",
    body: "Här hittar du dina personliga inställningar och dina normaliseringsregler.",
  },
};

// Stegen i den guidade rundturen
export const tourSteps: Array<{
  id: string;
  selector: string;
  title: string;
  body: string;
}> = [
  {
    id: "cv-upload",
    selector: '[data-tour="cv-upload"]',
    title: "1. Börja med ditt CV",
    body: "Ladda upp ditt CV i PDF eller DOCX. Vi analyserar det automatiskt och hittar dina kompetenser.",
  },
  {
    id: "job-filters",
    selector: '[data-tour="job-filters"]',
    title: "2. Hitta rätt jobb",
    body: "Använd sökfältet och filtren för att begränsa till jobb i din region eller bransch.",
  },
  {
    id: "match-button",
    selector: '[data-tour="match-button"]',
    title: "3. Matcha mot dina kompetenser",
    body: "Klicka på Matcha mot jobb-knappen så rangordnar vi annonserna efter hur väl de passar dig.",
  },
  {
    id: "applications-tab",
    selector: '[data-tour="applications-tab"]',
    title: "4. Spåra dina ansökningar",
    body: "När du sökt ett jobb dyker det upp under Mina ansökningar där du kan följa statusen.",
  },
  {
    id: "settings-menu",
    selector: '[data-tour="settings-menu"]',
    title: "5. Anpassa via inställningar",
    body: "Klicka på ditt namn uppe i högra hörnet för att hitta inställningar och normaliseringsregler.",
  },
];
